// PressabilityDebugView is not implemented in react-native-web
export function PressabilityDebugView() {
  return null;
}
//# sourceMappingURL=PressabilityDebugView.web.js.map